<div id="content-section">
  <div id="content-main" style="margin-right: 420px">
    <div id="content-sidebar" class="px-0" style="width: 400px; position: fixed; right: 20px">
      <h5 class="pt-1 px-3 pb-2">
        <div class="pull-right float-right">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearSearch()">Clear</button>
        </div>
        <span>
          Search&nbsp;&nbsp;
          <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="searching ? '' : search()"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
        </span>
      </h5>
      <div class="px-3 text-center">
        <div class="float-right">
          <app-badge badgeType="primary">{{ count }}</app-badge>
        </div>
        <pagination
          [boundaryLinks]="true"
          [itemsPerPage]="search_options.per_page"
          [maxSize]="3"
          (pageChanged)="search($event)"
          [totalItems]="count"
          [(ngModel)]="search_params.page"
          class="pagination-sm"
          previousText="&lsaquo;"
          nextText="&rsaquo;"
          firstText="&laquo;"
          lastText="&raquo;"
        ></pagination>
      </div>
      <div class="clearfix"></div>
      <hr class="my-1 mx-3" />
      <div id="search-form" class="px-3 py-2" style="overflow-y: scroll; border-bottom: 1px solid #ccc">
        <div class="form-group">
          <label>Date Range</label>
          <button id="date-range-search" class="btn btn-outline-secondary btn-block">
            <i class="fas fa-calendar-alt"></i>
            &nbsp;
            {{ dateResult }}
            &nbsp;
            <i class="fas fa-caret-down"></i>
          </button>
        </div>
        <div class="form-group">
          <label>Matter</label>
          <app-matter-search (matter_id)="search_params.matter_id = $event" (clearMatter)="search_params.matter_id = null"></app-matter-search>
        </div>
        <div class="form-group">
          <label>Deponent</label>
          <app-contact-search (contact_id)="search_params.deponent_id = $event" (clearContact)="search_params.deponent_id = null"></app-contact-search>
        </div>
        <div class="form-group">
          <label>Status</label>
          <select name='search_params_status' ngDefaultControl class="form-control" [(ngModel)]="search_params.status">
            <option *ngFor="let status of search_options.statuses" [value]="status">{{ status }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>Order by</label>
          <select name='search_params_ordered_by' ngDefaultControl class="form-control" [(ngModel)]="search_params.ordered_by">
            <option *ngFor="let ordered_by of search_options.ordered_by" [value]="ordered_by">{{ ordered_by }}</option>
          </select>
        </div>
        <div class="form-group">
          <label>In Order of</label>
          <select name='search_params_in_order_of' ngDefaultControl class="form-control" [(ngModel)]="search_params.in_order_of">
            <option *ngFor="let in_order_of of search_options.in_order_of" [value]="search_params.in_order_of">{{ in_order_of }}</option>
          </select>
        </div>
        <div class="form-group text-center">
          <button type="button" class="btn btn-primary btn-block" [disabled]="searching" (click)="search()">
            {{ searching ? 'Searching' : 'Search' }}<span *ngIf="searching">&nbsp;<i class="fas fa-spinner fa-fw fa-pulse"></i></span>
          </button>
        </div>
      </div>
    </div>
    <div id="content-inner" style="padding: 10px 20px 10px 20px">
      <div class="container-fluid container-shadow py-3 px-3">
        <h3>Oral Depositions</h3>
        <table class="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Matter Number</th>
              <th>Deponent</th>
              <th>Status</th>
              <th>Scheduled For</th>
              <th>Created by</th>
              <th>Participants</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let oralDeposition of oralDepositions">
              <td>
                <a *ngIf="oralDeposition.editing_allowed" [routerLink]="'/oral_depositions/' + oralDeposition.id + '/edit'"><i class="fas fa-pencil-alt"></i></a>
                <a [routerLink]="'/oral_depositions/' + oralDeposition.id">{{ oralDeposition.id }}</a>
              </td>
              <td>
                <a [routerLink]="'/matters/' + oralDeposition.matter_id">{{ oralDeposition.matter_number }}</a>
              </td>
              <td>
                <a [href]="'/contacts/' + oralDeposition.deponent_id">{{ oralDeposition.deponent_name }}</a>
                <br />
                {{ oralDeposition.deponent_address }}
              </td>
              <td>
                <app-oral-deposition-status [status]="oralDeposition.status"></app-oral-deposition-status>
              </td>
              <td>
                <span *ngIf="oralDeposition.scheduled && oralDeposition.scheduled_event && oralDeposition.scheduled_event.timing">
                  {{ oralDeposition.scheduled_event.timing }}
                </span>
              </td>
              <td>
                <a [href]="'/contacts/' + oralDeposition.created_by_contact_id">{{ oralDeposition.created_by_contact_name }}</a>
                <br />
                {{ oralDeposition.created_at }}
              </td>
              <td>
                <div *ngFor="let participant of oralDeposition.participants">
                  <a [href]="'/contacts/' + participant.id">{{ participant.name }}</a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
